import React, { useState } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import { Modal, Space } from 'antd';
function TechDocCheck(props) {
    const [open,setOpen] = useState(false)

    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.bjswd_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <div  style={{border:'2px solid #eee',margin:"10px",padding:'20px'}} >
                    <h2 style={{textAlign:"center",marginBottom:"20px"}}>{props.bjswd_name}</h2>
                    <div dangerouslySetInnerHTML={{__html:props.bjswd_content}}></div>
                </div>                
            </Modal>
        </>
    )
}

export default TechDocCheck